import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { buildSsoUrl, takeDestination } from '../lib/sso';

/**
 * Экран входа гипновейва.
 *
 * Порядок тот же, что у оксогона и суфлёра: сначала своё имя — чтобы человек
 * понимал, куда попал, — и одна кнопка входа общим аккаунтом Академии. Вход по
 * логину и паролю остался для старых записей, заведённых до общих аккаунтов,
 * но убран под ссылку: новым людям он не нужен и только сбивает.
 *
 * До этого экрана дело доходит, только если тихий вход не сработал —
 * см. AuthContext: на поддомене мы сначала молча спрашиваем гипнозио.
 */
const AuthPage = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  const { loginUser } = useAuth();
  const navigate = useNavigate();
  // Пусто, если REACT_APP_GIPNOZIO_ORIGIN не задан — тогда показываем только
  // вход по паролю, а не битую кнопку.
  const ssoUrl = buildSsoUrl();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await loginUser(login, password);

      if (result.success) {
        // Возвращаем туда, куда человек шёл до входа (ссылка на запись из
        // кабинета), иначе — на главную.
        navigate(takeDestination(), { replace: true });
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Что-то пошло не так. Попробуйте снова.');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            🎵 GipnoWave
          </h1>
          <p className="text-gray-600 mt-2">
            Записи ваших сессий
          </p>
        </div>

        {ssoUrl && (
          <div className="mb-6">
            <a
              href={ssoUrl}
              className="block w-full text-center bg-[#4353FF] text-white py-3 rounded-full font-semibold hover:bg-[#3643DD] transition-colors"
              data-testid="sso-login-button"
            >
              Войти
            </a>
            <p className="text-xs text-gray-500 text-center mt-3">
              через аккаунт Академии GIPNOZIO — Telegram, VK или почта
            </p>
            {!showPasswordForm && (
              <button
                type="button"
                onClick={() => setShowPasswordForm(true)}
                // Серее этого не делать: gray-400 на белом даёт 2,5:1 при норме
                // 4,5:1, а вертикальные отступы держат тач-цель выше 32px.
                className="block mx-auto mt-6 py-2 px-3 text-sm text-gray-600 hover:text-gray-900 underline underline-offset-2"
                data-testid="show-password-form"
              >
                У меня старый логин и пароль
              </button>
            )}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className={`space-y-4 ${ssoUrl && !showPasswordForm ? 'hidden' : ''}`}
        >
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Логин
            </label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4353FF] focus:border-transparent outline-none"
              placeholder="Введите ваш логин"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Пароль
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4353FF] focus:border-transparent outline-none"
              placeholder="••••••••"
              required
              minLength={6}
            />
          </div>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#4353FF] text-white py-2 rounded-lg font-medium hover:bg-[#3643DD] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="login-button"
          >
            {loading ? 'Загрузка...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthPage;
